import {Nav, Navbar} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import ApiRequest from "../../api/ApiRequest";

export default function MenuItems() {
  const location = useLocation();
  const profile = useSelector(state => state.user.profile);
  const [countOfNewAnnouncements, setCountOfNewAnnouncements] = useState(null);

  useEffect(() => {
    loadAnnouncements();
  }, [location]);

  const commonLinks = [
    {href: '/announcements', label: renderAnnouncementItem(), activeFor: ['/announcements', '/announcement']},
    {href: '/messages', label: 'Сообщения', activeFor: ['/messages']},
    // {href: '/', label: 'Мой профиль', activeFor: ['/profile', '/history', '/oauth', '/']},
  ];

  const adminLinks = [ // root, admin
    {href: '/sections', label: 'Предметы', activeFor: ['/sections', '/section']},
    {href: '/locations', label: 'Площадки', activeFor: ['/locations', '/location', '/report']},
    {href: '/participants', label: 'Участники', activeFor: ['/participants', '/participant']},
    // {href: '/requests', label: 'Заявки', activeFor: ['/requests']},
  ];

  const moderatorLinks = [
    {href: '/sections', label: 'Предметы', activeFor: ['/sections', '/section']},
    {href: '/locations', label: 'Площадки', activeFor: ['/locations', '/location', '/report']},
    {href: '/participants', label: 'Участники', activeFor: ['/participants', '/participant']},
  ];

  const juryLinks = [
    {href: '/solutions', label: 'Решения', activeFor: ['/solutions']},
    {href: '/appeals', label: 'Апелляции', activeFor: ['/appeals']},
  ];

  const managerLinks = [
    {href: '/locations', label: 'Мои площадки', activeFor: ['/locations', '/location', '/report']},
    {href: '/participants', label: 'Участники', activeFor: ['/participants', '/participant']},
  ];

  const participantLinks = [
    {href: '/sections', label: 'Мои предметы', activeFor: ['/sections', '/section', '/locations']},
  ];

  let links = [];

  if (['root', 'admin'].includes(profile.role.name)) {
    links = adminLinks.concat(commonLinks);
  } else if ('moderator' === profile.role.name) {
    links = moderatorLinks.concat(commonLinks);
  } else if ('jury' === profile.role.name) {
    links = juryLinks.concat(commonLinks);
  } else if ('manager' === profile.role.name) {
    links = managerLinks.concat(commonLinks);
  } else if ('participant' === profile.role.name) {
    links = participantLinks.concat(commonLinks);
  }

  // profile link
  if ('participant' === profile.role.name) {
    links = links.concat([{href: '/profile', label: 'Мой профиль', activeFor: ['/profile', '/history', '/oauth', '/']}]);
  } else {
    links = links.concat([{href: '/', label: 'Мой профиль', activeFor: ['/profile', '/oauth', '/']}]);
  }

  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav"/>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav variant="pills" defaultActiveKey="/" className="ml-auto">
          {links.map((link, index) => {
            return (
              <Link
                key={index}
                to={link.href}
                className={`nav-link ${compareUrl(location.pathname, link.activeFor) ? 'active' : ''}`}
              >
                {link.label}
              </Link>
            );
          })}
        </Nav>
      </Navbar.Collapse>
    </>
  );

  function compareUrl(url, rules) {
    const ROOT = '/';

    if (ROOT === url && rules.includes(ROOT)) {
      return true;
    }

    return rules.some((rule) => ROOT !== rule && url.startsWith(rule));
  }

  //-----------------------------------
  // Render methods
  //-----------------------------------
  function renderAnnouncementItem() {
    return (
      <>
        <span>Объявления</span>
        {renderCountOfNewAnnouncements()}
      </>
    )
  }

  function renderCountOfNewAnnouncements()
  {
    if (null === countOfNewAnnouncements || 0 === countOfNewAnnouncements) return;
    return <span className={'count'}>{countOfNewAnnouncements}</span>
  }

  //-----------------------------------
  // API calls
  //-----------------------------------
  async function loadAnnouncements() {
    const response = await ApiRequest.announcement.getCountOfNew();
    if (!response) return;
    setCountOfNewAnnouncements(response.announcements);
  }
}
